<template>
  <!-- 水位管理-->
  <div>
    <a-card style="width: 100%">
      <div class="table-page-search-wrapper">
        <a-tabs default-active-key="1" @change="callback">
          <a-tab-pane :key="1" tab="日水质报表"></a-tab-pane>
          <a-tab-pane :key="2" tab="月水质报表"></a-tab-pane>
        </a-tabs>
        <a-form layout="inline">
          <a-row :gutter="12">
            <a-col :md="6" :sm="24">
              <a-form-item label="选择时间">
                <a-date-picker
                  style="margin-left: 20px"
                  placeholder="请选择日期"
                  :allowClear="false"
                  v-model="query.STime"
                  :format="selectFormat"
                  :mode="selectMode"
                  :open="open"
                  @change="changeTime"
                  @openChange="openChange"
                  @panelChange="panelChange"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item>
                <a-button type="primary" @click="queryList">查询</a-button>
                <a-button type="primary" style="margin-left: 8px" @click="exportHandle()">导出</a-button>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row> </a-row>
        </a-form>
      </div>
      <a-table
        :loading="dataListLoading"
        :columns="columns"
        :data-source="list"
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
        :pagination="false"
        bordered
      >
        <template slot="percentageAction" slot-scope="text">
          <span v-if="text == null">0%</span>
          <span v-else>{{ text }}%</span>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import moment from 'moment'
import mixinViewModule from '@/mixin/common'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      columns: [
        {
          title: '地点',
          dataIndex: 'address',
          align: 'center',
          customRender: (text, row, index) => {
            return {
              children: <span>{text}</span>,
              attrs: {
                rowSpan: row.spans[0], //需要合并的数据
              },
            }
          },
        },
        {
          title: '类别',
          dataIndex: 'typeName',
          align: 'center',
        },
        {
          title: '检测总次数',
          dataIndex: 'monitoringSum',
          align: 'center',
        },
        {
          title: '合格总次数',
          dataIndex: 'qualifiedSum',
          align: 'center',
        },
        {
          title: '合格率(%)',
          dataIndex: 'percentage',
          align: 'center',
          scopedSlots: { customRender: 'percentageAction' },
        },
      ],
      queryUrl: '/pipe-network/water_works_report/quality/day',
      selectFormat: 'YYYY-MM-DD',
      selectMode: 'date',
      exportDataUrl: 'pipe-network/water_works_report/export/quality',
      exportFileName: '水质报表.xlsx',
      query: {
        STime: '',
        isDay: true,
        type: 7,
      },
      open: false,
    }
  },
  computed: {},
  mounted() {},
  created() {
    // this.queryList()
  },
  methods: {
    handleTableColumnSpanMethod(projectQuantities) {
      const uniqueKey = []
      //遍历源数据，address是第一列的名字，找到第一列从当前开始合并
      projectQuantities.forEach((item) => {
        if (uniqueKey.some((keyItem) => keyItem === item.address)) {
          item.spans = [0, 1]
          return
        }
        const projectQuantitiesFilterList = projectQuantities.filter(
          (projectItem) => item.address === projectItem.address
        )
        const projectLength = projectQuantitiesFilterList.length
        item.spans = [projectLength, 1]
        uniqueKey.push(item.address)
      })
      return projectQuantities
    },
    callback(key) {
      this.query.STime = ''
      if (key == '1') {
        this.selectFormat = 'YYYY-MM-DD'
        this.selectMode = 'date'
        this.queryUrl = '/pipe-network/water_works_report/quality/day'
        this.query.isDay = true
      } else if (key == '2') {
        this.selectFormat = 'YYYY-MM'
        this.selectMode = 'month'
        this.queryUrl = '/pipe-network/water_works_report/quality/month'
        this.query.isDay = false
        // this.columns = [
        //   {
        //     title: '时间',
        //     dataIndex: 'time',
        //     align: 'center',
        //   },
        //   {
        //     title: '累计流量',
        //     dataIndex: 'num',
        //     align: 'center',
        //   },
        // ]
      }
      this.queryList()
    },
    openChange(status) {
      if (status) {
        this.open = true
      } else {
        this.open = false
      }
    },
    changeTime(date, dateString) {
      console.log(date, dateString, 'change事件')
      this.query.STime = dateString
    },
    panelChange(value) {
      console.log(value)
      this.query.STime = value.format(this.selectFormat)
      this.open = false
    },
    queryList() {
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.query,
      }
      if (this.needPage) {
        params.page = 1
        this.pagination.current = 1
        params.limit = this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, {
          params,
        })
        .then(({ data }) => {
          this.dataListLoading = false
          if (this.needPage) {
            this.list = this.handleTableColumnSpanMethod(data) || []
            console.log(this.list)
            this.pagination.total = data.total ? parseInt(data.total) : 0
            if (data.total > 0) {
              this.isadd = false
            } else {
              this.isadd = true
            }
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
/deep/ .ant-form-item {
  margin-bottom: 12px;
}
</style>
